<script lang="ts">
  // A keyboard key hint: "⌘ K" in the sidebar search, the command palette, the
  // shortcut list, search fields and buttons. `md` has a raised bottom edge;
  // tone 'inherit' takes the colour of its container (inside a Button).
  import type { Snippet } from 'svelte';

  interface Props {
    size?: 'sm' | 'md';
    tone?: 'default' | 'inherit';
    title?: string;
    children: Snippet;
  }
  let { size = 'sm', tone = 'default', title, children }: Props = $props();
</script>

<kbd class="{size} {tone}" {title}>{@render children()}</kbd>

<style>
  kbd {
    flex-shrink: 0;
    font-family: inherit;
    font-size: var(--text-2xs);
    font-weight: var(--weight-semibold);
    line-height: var(--leading-tight);
    padding: var(--space-0_5) var(--space-1_5);
    border-radius: var(--radius-xs);
    border: 1px solid var(--border);
    background: var(--surface-3);
    color: var(--text-3);
  }
  .md {
    min-width: 24px;
    text-align: center;
    font-size: var(--text-xs);
    border-bottom-width: 2px;
    color: var(--text-2);
  }
  .inherit {
    border-color: transparent;
    background: color-mix(in srgb, currentColor 14%, transparent);
    color: inherit;
    opacity: 0.85;
  }
</style>
